export default "__VITE_ASSET__87fcb96d__"